import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { Calendar, Event, momentLocalizer } from 'react-big-calendar';
import { debounce } from 'ts-debounce';
import ChildAutoComplete, { ChildSearchResult } from '../ChildAutoComplete';
import ClassroomComboBox, { ClassroomSearchResult } from '../ClassroomComboBox';
import FacilityComboBox, { FacilitySearchResult } from '../FacilityComboBox';
import InstructorComboBox, { InstructorSearchResult } from '../InstructorComboBox';
import AccountAutoComplete, { AccountSearchResult } from '../AccountAutoComplete';
import { ScheduleEditModal } from '../Children/ScheduleEditModal';
import { ScheduleCreateModal, ScheduleTimes } from '../Children/ScheduleCreateModal';
import { DatePicker } from '@progress/kendo-react-dateinputs';
const DocumentTitle = require('react-document-title');

export type CustomEvent = {
    scheduleId: number;
    color: string;
} & Event;

type Props = RouteComponentProps<{}>;

type State = {
    view: string;
    events: CustomEvent[];
    isLoading: boolean;
    searchFromDate: string;
    searchToDate: string;
    currentViewDate: Date;
    localIANA: string;
    searchChild: ChildSearchResult | null;
    searchAccount: AccountSearchResult | null;
    searchFacility: FacilitySearchResult | null;
    searchClassroom: ClassroomSearchResult | null;
    searchInstructor: InstructorSearchResult | null;
    editLink: ApiLink | null;
    createTimes: ScheduleTimes | null;
    childName: string;
    requestHash: string;
}

const centerDiv = {
    margin: "auto",
    width: "50%",
    textAlign: "center",
    opacity: 0.4,
    fontSize: "14px",
    fontStyle: "italic"
} as React.CSSProperties;

const formPaddingLeft = {
    paddingRight: "10px"
} as React.CSSProperties;

const localizer = momentLocalizer(moment);

class CalendarAttendance extends React.Component<Props, State> {
    
    private dateTimeout!: NodeJS.Timeout;

    constructor(props: Props) {
        super(props);

        this.state = {
            view: 'month',
            events: [],
            isLoading: false,
            currentViewDate: moment().toDate(),
            searchFromDate: moment().startOf('month').format("YYYY-MM-DD").toString(),
            searchToDate: moment().endOf('month').format("YYYY-MM-DD").toString(),
            localIANA: Intl.DateTimeFormat().resolvedOptions().timeZone,
            searchAccount: null,
            searchChild: null,
            searchClassroom: null,
            searchFacility: null,
            searchInstructor: null,
            editLink: null,
            createTimes: null,
            childName: '',
            requestHash: '',
        }
        this.onNavigate = this.onNavigate.bind(this);
        this.onView = this.onView.bind(this);
        this.onSelectEvent = this.onSelectEvent.bind(this);
        this.onSelectSlot = this.onSelectSlot.bind(this);
        this.getCalendarEvents = this.getCalendarEvents.bind(this);
    }

    public componentWillMount() {
        this.getCalendarEventsDebounced();
    }

    private getCalendarEventsDebounced = debounce(this.getCalendarEvents, 300);

    public render() {
        if (!this.state.events) {
            return <React.Fragment>
                <div style={centerDiv}>Loading...</div>
            </React.Fragment>
        }

        return <React.Fragment>
            {this.state.editLink && <ScheduleEditModal
                CloseDialog={() => this.setState({ editLink: null })}
                RefreshSchedule={() => this.getCalendarEvents()}
                Link={this.state.editLink}
                ChildName={this.state.childName}
                ShowDelete={true} />}
            {this.state.createTimes && <ScheduleCreateModal
                CloseDialog={() => this.setState({ createTimes: null })}
                RefreshSchedule={() => this.getCalendarEvents()}
                Times={this.state.createTimes} />}
            <DocumentTitle title="Schedules" />
            <div className="row d-print-none">
                <div className="col-1">
                    <h1>Schedules</h1>
                </div>
                <div className="col-11 text-right">
                    <button className="btn btn-primary" onClick={() => this.props.history.push('/reports/attendanceReport')} style={{ margin: "0 10px 0 0" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-list">
                            <line x1="8" y1="6" x2="21" y2="6" />
                            <line x1="8" y1="12" x2="21" y2="12" />
                            <line x1="8" y1="18" x2="21" y2="18" />
                            <line x1="3" y1="6" x2="3" y2="6" />
                            <line x1="3" y1="12" x2="3" y2="12" />
                            <line x1="3" y1="18" x2="3" y2="18" />
                        </svg>
                        &nbsp;List View
                    </button>
                    <button className="btn btn-primary float-right" disabled={this.state.events.length === 0} onClick={this.print}>Download/Print</button>
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            <div className="card mb-2">
                <div className="card-body">
                    <div className="row" style={{ paddingTop: "10px" }}>
                        <div className="col-12">
                            <div className="form-inline">
                                <div className="form-group" style={formPaddingLeft}>
                                    <DatePicker
                                        value={this.state.currentViewDate}
                                        onChange={(e) => this.onNavigate(e.target.value, this.state.view)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <ChildAutoComplete
                                        className="form-control"
                                        style={{ color: '#007bff', width: "100%" }}
                                        classroomId={null}
                                        callbackFromParent={this.myCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <ClassroomComboBox
                                        style={{ color: '#007bff', width: "100%" }}
                                        callbackFromParent={this.myClassroomCBCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <FacilityComboBox
                                        style={{ color: '#007bff', width: "100%" }}
                                        callbackFromParent={this.myFacilityCBCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <InstructorComboBox
                                        style={{ color: '#007bff', width: "100%" }}
                                        callbackFromParent={this.myInstructorCBCallback.bind(this)} />
                                </div>
                                <div className="form-group" style={formPaddingLeft}>
                                    <AccountAutoComplete
                                        className="form-control"
                                        style={{ color: '#007bff', width: "100%", marginTop: "5px" }}
                                        callbackFromParent={this.myAccountACCallback.bind(this)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: "700px" }}>
                <Calendar
                    localizer={localizer}
                    date={this.state.currentViewDate}
                    events={this.state.events}
                    eventPropGetter={(event, start, end, isSelected) => {
                        if (event.color && this.state.view !== 'agenda') {
                            return { style: { backgroundColor: event.color, borderColor: event.color }}
                        }
                        return {}
                    }}
                    startAccessor="start"
                    endAccessor="end"
                    views={['month', 'week', 'work_week', 'day', 'agenda']}
                    onNavigate={(date, view) => this.onNavigate(date, view)}
                    onView={(view) => this.onView(view)}
                    onSelectEvent={this.onSelectEvent}
                    onSelectSlot={this.onSelectSlot}
                    popup={true}
                    selectable={true}
                    timeslots={4}
                />
            </div>
        </React.Fragment>;
    }

    private myCallback = (result: ChildSearchResult) => {
        this.setState({ searchChild: result }, this.getCalendarEventsDebounced);
    };

    private myAccountACCallback = (result: AccountSearchResult) => {
        this.setState({ searchAccount: result }, this.getCalendarEventsDebounced);
    };

    private myClassroomCBCallback = (result: ClassroomSearchResult) => {
        this.setState({ searchClassroom: result }, this.getCalendarEventsDebounced);
    };

    private myFacilityCBCallback = (result: FacilitySearchResult) => {
        this.setState({ searchFacility: result }, this.getCalendarEventsDebounced);
    };

    private myInstructorCBCallback = (result: InstructorSearchResult) => {
        this.setState({ searchInstructor: result }, this.getCalendarEventsDebounced);
    };

    private onSelectEvent(event: CustomEvent, e: React.SyntheticEvent) {
        if (!event.allDay)
        {
            e.preventDefault();
            this.setState({ editLink: { Rel: "GetSchedule", Method: "GET", Href: `api/ChildSchedule/Get/${event.scheduleId}` }, childName: event.title });
        }
    }

    private onSelectSlot(slotInfo: any) {
        this.setState({
            createTimes: {
                StartTime: slotInfo.start,
                EndTime: slotInfo.end
            }
        });
    }

    private onNavigate(currentViewDate: Date, view: string) {
        
        // Entered invalid date
        if (!currentViewDate) {
            return;
        }

        this.setState({ currentViewDate });

        // Month
        let data = {
            searchFromDate: moment(currentViewDate).startOf('month').format('YYYY-MM-DD').toString(),
            searchToDate: moment(currentViewDate).endOf('month').format('YYYY-MM-DD').toString(),
            view
        };

        if (view == 'week' || view == 'work_week')
        {
            data = {
                searchFromDate: moment(currentViewDate).startOf('week').format('YYYY-MM-DD').toString(),
                searchToDate: moment(currentViewDate).endOf('week').format('YYYY-MM-DD').toString(),
                view
            };
        }
        else if (view == 'day')
        {
            data = {
                searchFromDate: moment(currentViewDate).startOf('day').format('YYYY-MM-DD').toString(),
                searchToDate: moment(currentViewDate).endOf('day').format('YYYY-MM-DD').toString(),
                view
            };
        }
        else if (view == 'agenda')
        {
            data = {
                searchFromDate: moment(currentViewDate).startOf('day').format('YYYY-MM-DD').toString(),
                searchToDate: moment(currentViewDate).endOf('day').add(1, 'month').format('YYYY-MM-DD').toString(),
                view
            }
        }

        this.setState(data, this.getCalendarEvents);
    }

    private onView(view: string) {
        this.onNavigate(this.state.currentViewDate, view);
    }

    private print() {
        const bootstrap = (document.styleSheets[0] as CSSStyleSheet);
        const printRules = bootstrap.rules[bootstrap.rules.length - 1] as CSSMediaRule;
        const cssText = "@page { size: a3; }";
        for (var i=0; i < printRules.cssRules.length; i++) {
            if (printRules.cssRules[i].cssText === cssText) {
                printRules.deleteRule(i);
            }
        }
        window.print();
        printRules.insertRule(cssText, printRules.cssRules.length);
    }

    private getCalendarEvents() {
        const data = {
            FromDate: this.state.searchFromDate,
            ToDate: this.state.searchToDate,
            LocalIANA: this.state.localIANA,
            ChildId: (this.state.searchChild !== null) ? this.state.searchChild.ChildId : 0,
            AccountId: (this.state.searchAccount !== null) ? this.state.searchAccount.AccountId : 0,
            InstructorId: (this.state.searchInstructor !== null) ? this.state.searchInstructor.InstructorId : 0,
            ClassroomId: (this.state.searchClassroom !== null) ? this.state.searchClassroom.ClassroomId : 0,
            FacilityId: (this.state.searchFacility !== null) ? this.state.searchFacility.FacilityId : 0
        }
        const validationHash = Math.random().toString(36).substring(7);
        this.setState({ isLoading: true, requestHash: validationHash });
        fetchApi('/api/Reports/CalendarEventSearch', data, 'POST')
            .then((_data: CustomEvent[]) => {
                if (this.state.requestHash === validationHash) {
                    _data.map(x => { x.end = moment.utc(x.end).toDate(); x.start = moment.utc(x.start).toDate() });
                    this.setState({ events: _data, isLoading: false });
                }
            });
    }
}

export default CalendarAttendance;
